import React from 'react';
import { Col, Row } from 'react-grid-system';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import { windowExists } from '../../utils/index';
import Section from '../Section';
import { MediaCard, ContentCard, ProfileCard } from '../Card';
import Button from '../Button';

import styles from './mediaGridSection.module.scss';

function MediaGridSection(props) {
  const {
    components,
    fullBleed,
    images,
    itemsNumber,
    sectionButton,
    sectionSubtitle,
    sectionTitle,
    sectionTitleAlignment,
  } = props;

  const textAlignment = sectionTitleAlignment || 'left';
  const justifyContent = components && components.length && components.length === 1 ? 'center' : 'start';

  return (
    <Section fullBleed={fullBleed}>
      <Col>
        {sectionTitle && (
          <h2 style={{ textAlign: textAlignment }}>{sectionTitle}</h2>
        )}
        {sectionSubtitle && (
          <div
            style={{ textAlign: textAlignment, marginBottom: '48px' }}
            dangerouslySetInnerHTML={{
              __html: sectionSubtitle.childMarkdownRemark.html,
            }}
          />
        )}
        <Row justify={justifyContent}>
          {components && components.map((component) => {
            let sectionContent;

            if (component.__typename === 'ContentfulCompany') {
              sectionContent = (
                <MediaCard
                  {...component}
                  link={component.status === 'current' ? `company/${component.slug}` : null}
                  title={null}
                />
              );
            }

            if (component.__typename === 'ContentfulCard') {
              let Card = ContentCard;

              if (!windowExists) {
                return null;
              }

              if (typeof component.cardType !== 'undefined') {
                Card = require('../Card')[`${component.cardType}Card`];
              }

              sectionContent = <Card {...component} />;
            }

            if (component.__typename === 'ContentfulSpeaker') {
              let slug;
              let url;

              if (component.role && component.role.includes('Speaker')) {
                url = null;
              } else {
                slug = slugify(`${component.firstName} ${component.lastName}`, { lower: true });
                url = `people/${slug}`;
              }

              sectionContent = (
                <ProfileCard
                  {...component}
                  name={`${component.firstName} ${component.lastName}`}
                  image={component.imageSrc}
                  link={url}
                />
              );
            }

            if (component.__typename === 'ContentfulTextBlock') {
              sectionContent = (
                <div dangerouslySetInnerHTML={{
                  __html: component.content.childMarkdownRemark.html,
                }}
                />
              );
            }

            return (
              <Col xs={12} sm={6} md={12 / itemsNumber} key={component.id} style={{marginBottom: '24px'}}>
                {sectionContent}
              </Col>
            );
          })}

          {images && images.map(image => (
            <Col md={12 / itemsNumber} sm={6} xs={6} key={image.id}>
              <img src={image.file.url} alt={image.title} style={{ margin: 'auto', display: 'block' }} />
            </Col>
          ))}
        </Row>

        {sectionButton && (
          <Row>
            <Col>
              <div className={styles.btnContainer}>
                {sectionButton.map(cta => (
                  <Button
                    {...cta}
                    key={cta.id}
                    link={cta.url}
                    size="large"
                    isMobileFull
                    modifierclass={styles.btn}
                  >
                    {cta.label}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>
        )}
      </Col>
    </Section>
  );
}

export default MediaGridSection;

MediaGridSection.propTypes = {
  components: PropTypes.arrayOf(PropTypes.object),
  fullBleed: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.object),
  itemsNumber: PropTypes.string,
  sectionButton: PropTypes.arrayOf(PropTypes.object),
  sectionSubtitle: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  sectionTitle: PropTypes.string,
  sectionTitleAlignment: PropTypes.string,
};

MediaGridSection.defaultProps = {
  components: null,
  images: null,
  itemsNumber: '',
  sectionButton: null,
  fullBleed: false,
  sectionSubtitle: {
    childMarkdownRemark: {
      html: '',
    },
  },
  sectionTitle: '',
  sectionTitleAlignment: '',
};
